import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import countryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import AppAndroidDownloadAndEngagementFilter from "../../components/filters/AppDownloadEngagementFilter/android/AppAndroidDownloadAndEngagementFilter";
import AppAndroidDownloadEngagementFilterResult from "../../components/filters/AppDownloadEngagementFilter/android/AppAndroidDownloadAndEngagementFilterResult";
import type { IAppsFilterOptionsDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindAndroidDownloadAndEngagementFilter from "./AndroidDownloadAndEngagementFilter";

const createAndroidDownloadAndEngagementFilter = (description: IAppsFilterOptionsDto): SearchFilterInstance => {
    const countries = countryService.getCountriesByIds(description.androidDownloadsAndEngagement.supportedCountries);
    return {
        key: "downloadsAndEngagement",
        trackingName: "App Downloads and Engagement",
        apiCategory: "appsFilters",
        category: appsFilterCategoryMap.apps,
        visibility: "always-visible",
        title: { key: "si.find_apps.filters.android-download-and-engagement.title" },
        tooltipText: { key: "si.find_apps.filters.android-download-and-engagement.tooltip" },
        filter: new FindAndroidDownloadAndEngagementFilter({
            options: description.androidDownloadsAndEngagement,
            initialDtoValue: {
                country: WORLDWIDE_COUNTRY_ID,
            },
            countries,
        }),
        filterView: AppAndroidDownloadAndEngagementFilter,
        filterResultView: AppAndroidDownloadEngagementFilterResult,
    };
};

export default createAndroidDownloadAndEngagementFilter;
